import React from 'react';

import ArrayFieldTemplate from '@/components/common/Form/ArrayFieldTemplate';
import DefaultChildren from '@/components/common/Form/DefaultChildren';
import ErrorList from '@/components/common/Form/ErrorList';
import FieldTemplate from '@/components/common/Form/FieldTemplate';
import ObjectFieldTemplate from '@/components/common/Form/ObjectFieldTemplate';
import customWidgets from '@/components/common/Form/widgets';

const Theme = () => ({
  ArrayFieldTemplate,
  ErrorList,
  FieldTemplate,
  ObjectFieldTemplate,
  children: <DefaultChildren />,
  widgets: customWidgets,
});

export default Theme;
